import React, { useState, useEffect } from "react";
import yerlembg from "../images/yerlemicon.svg";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import "moment/locale/tr";
import "./style.css";
import { API_IP } from "./AppConfig/AppConfig";
import { Dropdown } from "primereact/dropdown";
import { Message } from "primereact/message";
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
import moment from "moment";

export default function SchoolLogPage({ setSidebarVisible }) {
  const currentDate = new Date();
  const nextDay = new Date(currentDate);
  nextDay.setDate(currentDate.getDate() + 1);
  const [data, setData] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalElements, setTotalElements] = useState(null);
  const [schoolList, setSchoolList] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [warningMessage, setWarningMessage] = useState("Okul seçiniz");
  addLocale("tr", {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: [
      "Pazartesi",
      "Salı",
      "Çarşamba",
      "Perşembe",
      "Cuma",
      "Cumartesi",
      "Pazar",
    ],
    dayNamesShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
    dayNamesMin: ["P", "Pt", "S", "Ç", "P", "C", "Ct"],
    monthNames: [
      "Ocak",
      "Şubat",
      "Mart",
      "Nisan",
      "Mayıs",
      "Haziran",
      "Temmuz",
      "Ağustost",
      "Eylül",
      "Ekim",
      "Kasım",
      "Aralık",
    ],
    monthNamesShort: [
      "Oca",
      "Şub",
      "Mar",
      "Nis",
      "May",
      "Haz",
      "Tem",
      "Ağu",
      "Eyl",
      "Eki",
      "Kas",
      "Ara",
    ],
    today: "Bugün",
    clear: "Temizle",
  });
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    fetchData();
  };

  const MStoDate = (ms) => {
    let date = new Date(ms);
    date = moment(date).format("DD-MM-YYYY HH:mm:ss");
    return date;
  };
  const items = Array.from({ length: 18 }, (v, i) => i);

  const bodyTemplate = () => {
    return <Skeleton></Skeleton>;
  };

  useEffect(() => {
    fetchSchool();
  }, []);

  const fetchSchool = async () => {
    try {
      const response = await fetch(
        `http://${API_IP}:8999/digitalgate/list`
        // Token olmadan doğrudan istek atılıyor, headers kısmı kaldırıldı
      );

      if (!response.ok) {
        throw new Error("Veri çekme hatası");
      }
      const data = await response.json();
      // Verileri işleme veya kullanma aşaması buraya eklenebilir
      setSchoolList(data);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
    }
  };
  const handleSelectSchool = async (e) => {
    const port = e.value;
    if (port) {
      setSelectedSchool(port);
      fetchData(port);
    } else {
      console.log("Geçersiz format");
    }
  };
  const fetchData = async (port) => {
    try {
      setDataLoading(true);

      const date = new Date(selectedDate);
      // Tarihi istediğiniz formata çevir
      const formattedDate =
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        date.getFullYear().toString().slice(-2) +
        " " +
        "23:59:59"; // Sabit olarak saat, dakika ve saniye belirlendi

      const apiUrl = `http://${API_IP}:${port}/mobile/getAllAbsenceByDate?date=${formattedDate}`;

      const logData = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Add any additional headers if needed
        },
      });
      const dataJson = await logData.json();
      setDataLoading(false);
      if (dataJson.length > 0) {
        setData(dataJson);
      } else {
        setData([]);
        setSelectedSchool(null);
        setWarningMessage("Seçilen tarihte yoklama kaydı bulunamadı");
      }
      setTotalElements(dataJson.totalElements);
    } catch (error) {
      console.error("catch oluştu:", error);
    }
  };

  return (
    <div className="w-full h-full py-4 px-36 ">
      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>
      <div className="relative flex h-full items-center justify-start gap-6 flex-col">
        <img
          src={yerlembg}
          alt="Logo"
          className="absolute h-full object-cover z-0 "
        />
        <div className="flex flex-row w-full gap-4">
          <Dropdown
            value={selectedSchool}
            options={schoolList
              .filter((item) => item.status) // Durumu true olanları filtrele
              .map((item) => ({
                label: item.description,
                value: item.port,
              }))}
            filter
            className="w-full"
            optionLabel="label"
            placeholder="SMS göndermek istediğiniz okulu seçiniz"
            onChange={handleSelectSchool}
          />
          <Calendar
            locale="tr"
            className="rounded-lg bg-[#6366F1] border-transparent"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.value)}
            showIcon
          />
        </div>

        {selectedSchool && data.length > 0 ? (
          dataLoading ? (
            <DataTable
              value={items}
              style={{ width: "100%" }}
              className="p-datatable-striped"
            >
              <Column header="id" body={bodyTemplate}></Column>
              <Column header="Veli" body={bodyTemplate}></Column>
              <Column header="Öğrenci" body={bodyTemplate}></Column>
              <Column header="Kampüs" body={bodyTemplate}></Column>
              <Column header="Okul" body={bodyTemplate}></Column>
              <Column header="Yoklama Tarihi" body={bodyTemplate}></Column>
            </DataTable>
          ) : (
            <div className="w-full z-1 ">
              <DataTable size="small" value={data} style={{ width: "100%" }}>
                <Column
                  field="id"
                  className="w-1/12 text-black"
                  header="ID"
                  body={(
                    rowData // Her bir satır için özel işlem yapma işlemi
                  ) => <p className="text-black ">{rowData.id}</p>}
                />

                <Column
                  field="studentName"
                  className="w-2/12  text-black"
                  header="Öğrenci "
                  body={(rowData) => (
                    <p className="text-black ">
                      {rowData.student.name + " " + rowData.student.surname}
                    </p>
                  )}
                />

                <Column
                  field="schoolName"
                  className="w-2/12  text-black"
                  header="Okul"
                  body={(rowData) => (
                    <p className="text-black">{rowData.school.name}</p>
                  )}
                />
                <Column
                  field="parentName"
                  className="w-2/12  text-black"
                  header="Veli"
                  body={(rowData) => (
                    <p className="text-black">
                      {rowData.parent.name + " " + rowData.parent.surname}
                    </p>
                  )}
                />
                <Column
                  field="parentPhone"
                  className="w-2/12  text-black"
                  header="Veli No"
                  body={(rowData) => (
                    <p className="text-black font-semibold">
                      {rowData.parent.phone}
                    </p>
                  )}
                />
                <Column
                  field="absenceDate"
                  className="w-3/12 text-black "
                  header="Tarih"
                  body={(rowData) => (
                    <p className="text-black ">{MStoDate(rowData.date)}</p>
                  )}
                />
              </DataTable>
              <Paginator
                className="z-1 my-2 bg-transparent"
                first={first}
                rows={rows}
                totalRecords={totalElements}
                onPageChange={onPageChange}
              />
            </div>
          )
        ) : (
          <div className="flex  w-full h-full">
            <Message
              className="w-full"
              severity="warn"
              text={warningMessage}
            ></Message>
          </div>
        )}
      </div>
    </div>
  );
}
